// Smart Sash Admin Panel - Certification Answer List Component
// Reusable component for displaying and editing answer options

import React from 'react';
import { CertificationAnswer } from '@/models';

export interface AnswerListProps {
  answers: CertificationAnswer[];
  correctAnswer: string | null | undefined;
  isEditMode: boolean;
  inputBgClass: string;
  onAnswerTextChange: (answerId: string, text: string) => void;
  onCorrectAnswerChange: (answerId: string) => void;
}

export const AnswerList: React.FC<AnswerListProps> = ({
  answers,
  isEditMode,
  inputBgClass,
  onAnswerTextChange,
  onCorrectAnswerChange,
}) => {
  return (
    <div className="mb-4">
      <label className="form-label fw-semibold">Answer Options</label>
      <div className="list-group">
        {answers.map((answer) => (
          <div
            key={answer.id}
            className={`list-group-item d-flex align-items-center gap-3 ${
              answer.isCorrect ? 'list-group-item-success' : ''
            }`}
          >
            {/* Answer ID badge */}
            <span
              className={`badge ${
                answer.isCorrect ? 'bg-success' : 'bg-secondary'
              }`}
              style={{ minWidth: '28px' }}
            >
              {answer.id.toUpperCase()}
            </span>

            {/* Answer text input/display */}
            {isEditMode ? (
              <input
                type="text"
                className={`form-control ${inputBgClass}`}
                value={answer.text}
                onChange={(e) => onAnswerTextChange(answer.id, e.target.value)}
                placeholder={`Answer ${answer.id.toUpperCase()}`}
              />
            ) : (
              <span className={`flex-grow-1 ${!answer.text ? 'text-muted fst-italic' : ''}`}>
                {answer.text || 'Empty'}
              </span>
            )}

            {/* Correct answer indicator (edit mode: radio, view mode: badge) */}
            {isEditMode ? (
              <div className="form-check mb-0">
                <input
                  type="radio"
                  className="form-check-input"
                  name="correctAnswer"
                  id={`correct-${answer.id}`}
                  checked={answer.isCorrect}
                  onChange={() => onCorrectAnswerChange(answer.id)}
                />
                <label
                  className="form-check-label small"
                  htmlFor={`correct-${answer.id}`}
                >
                  Correct
                </label>
              </div>
            ) : (
              answer.isCorrect && (
                <span className="badge bg-success">
                  <i className="fas fa-check me-1"></i>Correct
                </span>
              )
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnswerList;
